<template>
<div class="chapter">
<div class="inner_page">
<div class="pbox">
<div class="pbox1">
<p class="part-tit"><b>Pinkeeps<br/><span class="sm">AND</span><br/>Pincushions</b></p>
</div>
</div>
<p class="image"><img alt="" src="images/pg11.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?761bd6d8